import { render, staticRenderFns } from "./SalariesPreview.vue?vue&type=template&id=4dc0b6cc&scoped=true&"
import script from "./SalariesPreview.vue?vue&type=script&lang=js&"
export * from "./SalariesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0b6cc",
  null
  
)

export default component.exports